import { Buttons, CancelButton, Drawer, Form } from '~/components';
import { useDocumentTitle } from '~/hooks';
import React from 'react';
import ReadTextbox from '~/components/read-only/ReadTextbox';
import opportunityStageCategories from '~/lookups/opportunity-stage-categories';

function OpportunityStageViewDrawer({ opportunityStage, onClose }) {
  const title = 'View Opportunity Stage';
  useDocumentTitle(title);

  function handleClose() {
    if (onClose) {
      onClose();
    }
  }

  return (
    <Drawer isOpen title={title} byline="Custom Data" onClose={handleClose}>
      <Form.Section title="Details">
        <Form.Control>
          <ReadTextbox label="Name" value={opportunityStage.name} />
        </Form.Control>
        <Form.Control>
          <ReadTextbox label="Probability" value={opportunityStage.probability} prefix="%" />
        </Form.Control>
        <Form.Control>
          <ReadTextbox label="Category" value={opportunityStageCategories[opportunityStage.statusId].name} />
        </Form.Control>
        <Form.Control>
          <ReadTextbox label="Pipeline" value={opportunityStage.opportunityPipeline?.name} />
        </Form.Control>
        <Form.Control>
          <ReadTextbox label="Description" value={opportunityStage.description} textarea />
        </Form.Control>
      </Form.Section>

      <Drawer.Actions>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Close</CancelButton>
        </Buttons>
      </Drawer.Actions>
    </Drawer>
  );
}

export default OpportunityStageViewDrawer;
